<template>
    <div class="tr-data__cell">
        <div
            class="tr-data__dt"
        >Sklepy {{ group.count }} z {{ sum }} - cena {{ group.price | currency }}</div>
        <div class="tr-data__dd">
            <div class="input-currency input-currency-sm mp-labels-form__input1">
                <input
                    type="text"
                    :placeholder="(+group.price).toFixed(2)"
                    class="form-control form-control-sm"
                    v-model="price"
                    @keyup="changePrice"
                />
            </div>
            <input
                type="number"
                class="form-control form-control-sm mp-labels-form__input2"
                min="1"
                v-model="copies"
                @change="selectLabel(true)"
                @keyup="changeCopies"
            />
            <ui-checkbox-input
                :name="`label-group-${id}`"
                v-model="selectedGroup"
            />
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            copies: 1,
            price: null
        }
    },
    props: {
        group: {
            type: Object,
            required: true
        },
        sum: {
            type: Number,
            required: true
        },
        id: {
            type: String,
            required: true
        },
        product: {
            type: Object,
            required: true
        },
        productId: {
            type: Number,
            required: true
        },
        subscriptionIds: {
            type: Array,
            required: true
        }
    },
    methods: {
        selectLabel(value) {
            if (value && !this.price) {
                this.price = (+this.group.price).toFixed(2)
            }
            this.$store.dispatch('selectLabel', {
                subscription_id: this.subscriptionIds,
                product_id: this.productId,
                price_normal: this.price,
                print_copies: +this.copies,
                value
            })
        },
        changeCopies() {
            if (this.copies === '') {
                this.copies = 1
            }
            this.selectLabel(true)
        },
        changePrice() {
            if (this.price) {
                this.selectLabel(true)
            } else {
                this.selectLabel(false)
            }
        }
    },
    computed: {
        selectedGroup: {
            get() {
                return this.$store.getters.getSelectedLabelGroupBoolean({
                    subId: this.subscriptionIds[0],
                    productId: this.productId
                })
            },
            set(value) {
                this.selectLabel(value)
            }
        }
    }
}
</script>